(function () {
  function initGallery(section) {
    var gallery = section.querySelector('media-gallery.product-gallery-carla');
    if (!gallery) return;

    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var slider = viewer && viewer.querySelector('[id^="Slider-Gallery"]');
    var dots = gallery.querySelector('[data-product-gallery-dots]');
    if (!slider || gallery.dataset.cmMobileFitReady) return;
    gallery.dataset.cmMobileFitReady = 'true';

    var dotEls = dots ? dots.querySelectorAll('.product-gallery-carla__dot') : [];
    var slides = slider.querySelectorAll('.product__media-item');

    function setActiveDot(index) {
      fitViewer(index);
      if (!dots || index < 0 || index >= dotEls.length) return;
      dotEls.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function indexFromScroll() {
      slides = slider.querySelectorAll('.product__media-item');
      if (!slides.length) return 0;
      var scrollCenter = slider.scrollLeft + slider.clientWidth / 2;
      var closest = 0;
      var minDist = Infinity;
      slides.forEach(function (slide, i) {
        var center = slide.offsetLeft + slide.offsetWidth / 2;
        var dist = Math.abs(scrollCenter - center);
        if (dist < minDist) {
          minDist = dist;
          closest = i;
        }
      });
      return closest;
    }

    function fitViewer(index) {
      if (!window.matchMedia('(max-width: 1023px)').matches) {
        slider.style.removeProperty('height');
        return;
      }
      var currentSlides = slider.querySelectorAll('.product__media-item');
      var active = currentSlides[index] || slider.querySelector('.product__media-item.is-active') || currentSlides[0];
      var media = active && active.querySelector('.product-media-container');
      if (!media) return;
      var height = Math.ceil(media.getBoundingClientRect().height);
      var value = height + 'px';
      if (height > 0 && slider.style.height !== value) slider.style.height = value;
    }
    new ResizeObserver(function () { fitViewer(indexFromScroll()); }).observe(slider);
    new MutationObserver(function () { fitViewer(indexFromScroll()); }).observe(slider, { childList: true, subtree: true });
    window.matchMedia('(max-width: 1023px)').addEventListener('change', function () { fitViewer(indexFromScroll()); });
    gallery.addEventListener('click', function () {
      requestAnimationFrame(function () { fitViewer(indexFromScroll()); });
    });
    fitViewer(0);

    slider.addEventListener(
      'scroll',
      function () {
        setActiveDot(indexFromScroll());
      },
      { passive: true }
    );

    viewer.addEventListener('slideChanged', function (event) {
      var current = event.detail && event.detail.currentElement;
      if (!current) return;
      var index = Array.prototype.indexOf.call(slides, current);
      if (index >= 0) setActiveDot(index);
    });
  }

  function initAll() {
    document.querySelectorAll('.product--thumbnail_left').forEach(function (productEl) {
      var section = productEl.closest('.shopify-section');
      if (section) initGallery(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.product--thumbnail_left')) {
      initGallery(event.target);
    }
  });
})();


(function () {
  function setup() {
    document.querySelectorAll('.product--thumbnail_left .thumbnail-slider').forEach(function (rail) {
      if (rail.dataset.cmScrollReady) return;
      rail.dataset.cmScrollReady = 'true';
      var list = rail.querySelector('.thumbnail-list');
      var prev = rail.querySelector('button[name="previous"]');
      var next = rail.querySelector('button[name="next"]');
      if (!list || !prev || !next) return;
      function vertical() { return window.matchMedia('(min-width: 1024px)').matches; }
      function update() {
        var pos = vertical() ? list.scrollTop : list.scrollLeft;
        var max = vertical() ? list.scrollHeight - list.clientHeight : list.scrollWidth - list.clientWidth;
        if (prev.disabled !== (pos <= 2)) prev.disabled = pos <= 2;
        if (next.disabled !== (pos >= max - 2)) next.disabled = pos >= max - 2;
      }
      rail.addEventListener('click', function (event) {
        var button = event.target.closest('.slider-button');
        if (!button) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        var amount = (vertical() ? list.clientHeight : list.clientWidth) * .8 * (button === prev ? -1 : 1);
        list.scrollBy({ top: vertical() ? amount : 0, left: vertical() ? 0 : amount, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, true);
      list.addEventListener('scroll', update, { passive: true });
      var buttonObserver = new MutationObserver(update);
      [prev, next].forEach(function (button) { buttonObserver.observe(button, { attributes: true, attributeFilter: ['disabled'] }); });
      new ResizeObserver(update).observe(list);
      var viewer = rail.closest('media-gallery').querySelector('[id^="GalleryViewer"]');
      if (viewer) {
        new ResizeObserver(function () {
          rail.style.setProperty('--cm-gallery-height', viewer.getBoundingClientRect().height + 'px');
          update();
        }).observe(viewer);
      }
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  new MutationObserver(setup).observe(document.documentElement, { childList: true, subtree: true });
})();
